import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import WhyDeliver from "@/components/WhyDeliver";
import Dimensions from "@/components/Dimensions";
import Showcase from "@/components/Showcase";
import InfoSections from "@/components/InfoSections";
import Faq from "@/components/Faq";
import QuoteSection from "@/components/QuoteSection";
import Footer from "@/components/Footer";

export const scrollToId = (selector) => {
  const el = document.querySelector(selector);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div id="top" className="min-h-screen overflow-x-clip bg-obsidian text-white">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <WhyDeliver />
        <Dimensions />
        <Showcase />
        <InfoSections />
        <Faq />
        <QuoteSection />
      </main>
      <Footer />
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
